import { shuffle, restoreShuffle } from './arrayUtils.js';
// RSA私钥
const mixedKey ="R/Q25mj7WhfHP6S5Q/e/Yxwd8V67cDJL99y+ECTkVnS6NPxD77IcYrnwEZAW76LU6vlbNn5AkEApvQ+UXQU06U6e6/XuIJLjQsYqZsmzxZOQxA3yKx2s1uIayzplPsO9Hs+Q+4GSUwutfEOUbSiHXaJp0uRAYPByn0eIPAxiP8O6iG4QJBAP1Nhpy10GWdnAOSDBrg1+XNaVZgyLp715TLKkOi4arTZgEyK60w0QdtAaoGrvmfs6zjhWCAqei81NrUq9OzHlcCQQDXvvAeIHCEG4o47Jn5oDBaA936CL8s01c4/MIICdwIBADANBgkqhkiG9w0BAQEFAASCAmEwggJdAgEAAoGBANV5CS4CYqxJK1Qq0rlw3o8CEtZsYuxf6zqq08m5CArWRROEiBXmYjLEDGJn2kBFoHfAEJmAFi+uwGf94ck096xfzYgtPLc2cI2nbHrWngT1uQsJbP7UF9E4gU/mPM5zH/8ZZVkWa+NO/vY+Ov6tiWUg67g+m9KuKMhuVp4CGHy+BWTLlXlqqUXuBLbpdN/znC5Irj8MMqtmnCglpTScixF35w/7govIQZNOZryMET4nLc9rIAFvtGR5yzgCSbjvTXGvsx2MnsOAbefYtW6YjupHcaTTTEm3KQJAFRC4o0hplAyYV2yKsDv63J8qCmLWP8s25gKjtsuLBbC3NS2udKxWqdH0YkqHfy8ZYrrrZCt68IfEuBfoXdNeCQJBAMe9P6lrPwzfqnTRW+rSdAbNC3LL5xRa987AxOT70P/p4gdTr9+3v+P6Y=/uIbX+zMsxHqzhGVdpEGfAgMBAAECgYBNubIj9G5k+Ic0MBtltbjzLPga5n";
const swapsArray = [
    [
        12,
        4
    ],
    [
        11,
        4
    ],
    [
        10,
        9
    ],
    [
        9,
        4
    ],
    [
        8,
        6
    ],
    [
        7,
        2
    ],
    [
        6,
        5
    ],
    [
        5,
        0
    ],
    [
        4,
        2
    ],
    [
        3,
        0
    ],
    [
        2,
        2
    ],
    [
        1,
        1
    ]
]
export {mixedKey,swapsArray};
// const originalKey = "";
// const keyArray = originalKey.split("/");
// const { shuffled, swaps } = shuffle(keyArray);
// const restoredArray = restoreShuffle(shuffled, swaps);
// const keyStringFalse = shuffled.join("/");
// const keyString = restoredArray.join("/");
// console.log('原始秘钥:', originalKey);
// console.log('交换步骤:', swaps);
// console.log('打乱后的秘钥:', keyStringFalse);
// console.log('恢复后的秘钥:', keyString);